/* eslint-disable react/prefer-es6-class */
import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import update from 'react-addons-update';
import Select from 'react-select';
// require('react-select/dist/react-select.css');

import Modal from '../../../../common/components/Modal';

var EditCategoryModal = createReactClass({

    getInitialState: function () {
        return {
            edited: false,
            edits: {
                categoryName: "",
                displayName: this.props.category.displayName || null,
                categoryDescription: "",
                parentCategoryID: ""
            }
        };
    },

    save: function () {
        if (this.valid()) {
            this.props.actions.edit({
                categoryID: this.props.category.categoryID,
                categoryName: this.state.edits.categoryName,
                displayName: this.state.edits.displayName,
                categoryDescription: this.state.edits.categoryDescription,
                childOf: this.state.edits.parentCategoryID || null
            });
            this.props.toggle();
        }
    },

    valid: function () {
        var failed = [], messages = [];

        if (this.state.edited && this.state.edits.categoryName === '') {
            failed.push('categoryName');
            messages.push('Category Name is Required');
        }
        if (this.state.edited && this.state.edits.displayName === '') {
            this.state.edits.displayName = null;
        }

        if (failed.length) {
            this.setState({
                validators: failed
            });

            return false;
        }
        return true;
    },

    transferState: function () {
        this.setState(function (state, props) {
            return {
                edited: true,
                edits: {
                    categoryName: props.category.categoryName,
                    displayName: this.state.edits.displayName,
                    categoryDescription: props.category.categoryDescription,
                    parentCategoryID: props.category.parentCategoryID
                }
            };
        });
    },

    handleParentCategoryChange: function (value) {
        if (value === null) {
            // parent was removed from the category
            // must be an empty string for select but null when saved
            value = ""
        }
        if (!this.state.edited) this.transferState();

        var updates = {};
        updates['parentCategoryID'] = {$set: value.value};
        this.setState(function (state) {
            return {
                edits: update(state.edits, updates)
            };
        });
    },

    handleChange: function (event) {
        if (!this.state.edited) this.transferState();

        var updates = {};
        updates[event.target.name] = {$set: event.target.value};

        this.setState(function (state) {
            return {
                edits: update(state.edits, updates)
            };
        });
    },

    render: function () {
        var validParentCategories = [];
        this.props.categories.map(function (category) {
            if (
                category.parentCategoryID === null &&
                category.categoryID !== this.props.category.categoryID &&
                !this.props.nested.hasOwnProperty(category.categoryID) &&
                !this.props.isParent
            ) {
                validParentCategories.push(
                    { value: category.categoryID, label: category.categoryName }
                );
            }
        }, this);

        var { categoryName, displayName, categoryDescription } = (this.state.edited) ? this.state.edits : this.props.category;

        return (<Modal
            cancelModal={this.props.toggle}
            saveAction={<button className="btn btn-primary" onClick={this.save} disabled={!this.state.edited}>
                <i className="fa fa-save" /> Save
            </button>}>
            <Modal.Header>Edit Category</Modal.Header>

            <Modal.Body>
                <label>Parent Category</label>
                <Select
                    name="Categories"
                    value={(this.state.edited ?
                        this.state.edits.parentCategoryID :
                        this.props.category.parentCategoryID) ||
                            ''}
                    options={validParentCategories}
                    onChange={this.handleParentCategoryChange}
                />

                <div style={{margin: '2rem 0'}}/>

                <label>Category Name</label>
                <input
                    className="form-control"
                    name="categoryName"
                    value={categoryName}
                    onChange={this.handleChange}
                />

                <div style={{margin: '2rem 0'}}/>

                <label>Display Name</label>
                <input
                    className="form-control"
                    name="displayName"
                    placeholder="(optional) Public friendly name"
                    value={displayName}
                    onChange={this.handleChange}
                />

                <div style={{margin: '2rem 0'}}/>

                <label>Category Description</label>
                <textarea className="form-control" name="categoryDescription" value={categoryDescription} onChange={this.handleChange} />
            </Modal.Body>

            <Modal.Footer />
        </Modal>);
    }

});

export default EditCategoryModal;
